import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from 'components/Icons/types'

const Svg = styled.svg`
  height: 16px;
  width: 16px;
`

export const FilledCircleCheckIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="#00C875" />
      <path
        d="M6.36665 12.001L2.56665 8.20104L3.51665 7.25104L6.36665 10.101L12.4833 3.98438L13.4333 4.93438L6.36665 12.001Z"
        fill="white"
      />
    </Svg>
  )
}
